import { ReactNode } from "react";
import styled from "styled-components";

/**
 * Animates open/close by transitioning the grid row from 0fr to 1fr — smooth
 * for unknown content heights without measuring. Content stays mounted (just
 * clipped) so drag contexts and scroll positions survive a collapse.
 */
const Grid = styled.div<{ $open: boolean; $fill: boolean }>`
  display: grid;
  grid-template-rows: ${({ $open }) => ($open ? "1fr" : "0fr")};
  transition: grid-template-rows 0.22s ease;
  min-height: 0;
  ${({ $fill, $open }) => ($fill && $open ? "flex: 1;" : "")}
`;

const Clip = styled.div`
  overflow: hidden;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

export const Collapsible = ({
  open,
  fill = false,
  children,
}: {
  open: boolean;
  /** Fill the available flex height when open (for scrollable sections). */
  fill?: boolean;
  children: ReactNode;
}) => (
  <Grid $open={open} $fill={fill}>
    <Clip>{children}</Clip>
  </Grid>
);
